<template lang="pug">
  div
    div(class="info-header")
      | {{$t('select_country2')}}
    el-form-item(:label='$t("countryofstudy")',
      :prop="fromConsideration ? 'country.name' : 'titles.country.name'")
      el-select.countries.hideSMup(v-model='title.country.name' ,  @change="countrySelected",
        :placeholder="$t('country')", filterable,
        :class="{ 'country-inactive': countryInactive }")
        el-option(v-for="country in countryOptions", :key="country.id", :label="country.name",
          :value="country.id")
          | {{country.name.length > 30 ? country.name.substring(0, 28) + '...' : country.name}}
        el-option(:label="this.$t('other_option')", value='other')
      el-select.countries.hideSMdown(v-model='title.country.name' ,  @change="countrySelected",
        :placeholder="$t('country')", filterable,
        :class="{ 'country-inactive': countryInactive }")
        el-option(v-for="country in countryOptions", :key="country.id", :label="country.name",
          :value="country.id")
        el-option(:label="this.$t('other_option')", value='other')
      inactive-country-warning(:show="countryInactive")
      div.hideSMup(:class="{ 'country-inactive-text': countryInactive }")
        | {{title.country.name && title.country.name.length > 30 ? title.country.name : ''}}
    el-tooltip(placement='right')
      div(slot='content')
        | {{ $t("hint_other_country") }}
      i.el-icon-question
    el-form-item(:label="this.$t('other_country')",
      :prop="fromConsideration ? 'country.countryInserted' : 'titles.country.countryInserted'",
      v-show="title.country.name === 'other'")
      el-input.big(:placeholder="$t('fill_in_country')",
        v-model='title.country.countryInserted',
        @change="countryInsertedChanged",
        @input="title.country.countryInserted = title.country.countryInserted.toUpperCase()")
    div
    el-form-item(:label="$t('university')", v-loading="gettingUniversities",
      :prop="fromConsideration ? 'university.name' : 'titles.university.name'")
      el-select.big.hideSMup(v-model='title.university.name' , @change="universitySelected",
        :placeholder="$t('universities')", :disabled="disableUniversity", filterable,
        :class="selectedUniversityColorClass")
        el-option(v-for="university in universities", :key="university.id",
          :label="university.name", :value="university.id",
          :class="universityOptionClass(university)")
          | {{university.name.length > 30 ? university.name.substring(0, 28) + '...' : university.name}}
        el-option(:label="this.$t('other_option')", value='other', key="other")
      el-select.big.hideSMdown(v-model='title.university.name' , @change="universitySelected",
        :placeholder="$t('universities')", :disabled="disableUniversity", filterable,
        :class="selectedUniversityColorClass")
        el-option(v-for="university in universities", :key="university.id",
          :label="university.name", :value="university.id",
          :class="universityOptionClass(university)")
          | {{university.name.length > 30 ? university.name.substring(0, 28) + '...' : university.name}}
        el-option(:label="this.$t('other_option')", value='other', key="other")
      div(:class="selectedUniversityColorClass")
        | {{title.university.name && title.university.name.length > 30 ? title.university.name : ''}}
    el-tooltip(placement='right')
      div(slot='content')
        p(v-if="showUniversityLegend", v-html="$t('university_recognition_green')")
        p(v-if="showUniversityLegend", v-html="$t('university_recognition_red')")
        p(v-if="showUniversityLegend", v-html="$t('university_recognition_blue')")
        p(v-html="$t('hint_other_university')")
      i.el-icon-question
    //- Replaced by the university request button below. A locked application
    //- still shows the inserted university name, without the validation prop.
    //- el-form-item(:label="$t('new_university')"
    //-   :prop="fromConsideration ? 'university.universityInserted' : 'titles.university.universityInserted'",
    //-   v-show="title.university.name === 'other'")
    //-   el-input.big(type="text", :placeholder="$t('fill_in_uni')",
    //-     v-model='title.university.universityInserted',
    //-     @change="universityInsertedChanged",
    //-     @input="title.university.universityInserted = title.university.universityInserted.toUpperCase()")
    el-form-item(:label="$t('new_university')",
      v-show="title.university.name === 'other' && applicationFinalSaved")
      el-input.big(type="text", :placeholder="$t('fill_in_uni')",
        v-model='title.university.universityInserted')
    el-form-item(:label="$t('new_university')",
      v-if="title.university.name === 'other' && !applicationFinalSaved")
      el-tooltip(placement='top')
        div(slot='content')
          | {{ universityRequestSent ? $t('university_request_sent_tooltip') : $t('university_request_tooltip') }}
        el-button(size="small", plain,
          :type="universityRequestSent ? 'success' : 'primary'",
          :icon="universityRequestSent ? 'el-icon-check' : 'el-icon-message'",
          :disabled="universityRequestSent || !hasContactDetails",
          @click="universityRequestVisible = true")
          | {{ universityRequestSent ? $t('university_request_sent') : $t('send_university_request') }}
      el-button.contact-details-link(type="text",
        v-if="!hasContactDetails && !universityRequestSent",
        @click="personalDataVisible = true")
        | {{ $t('fill_contact_details') }}
    el-form-item(:label="$t('titleofstudy')",
      :prop="fromConsideration ? 'certificationTitle' : 'titles.certificationTitle'")
      el-input.biggest(v-model='title.certificationTitle', @change="fieldChanged",
        @input="title.certificationTitle = title.certificationTitle.toUpperCase()")
    el-tooltip(placement='right')
      div(slot='content')
        | {{ $t("hint_title") }}
      i.el-icon-question
    //- div {{title.certificationTitle}}
    div
      el-form-item(:label="$t('ects')"
        :prop="fromConsideration ? 'credits' : 'titles.credits'")
        el-input(v-model.number='title.credits' inputmode="numeric" @change="fieldChanged")
      el-tooltip(placement='right')
        div(slot='content')
          | {{ $t("hint_credits") }}
        i.el-icon-question
    div
      el-form-item(:label="$t('enroll_date')"
        :prop="fromConsideration ? 'dateOfRegistration' : 'titles.dateOfRegistration'")
        el-date-picker(v-model="title.dateOfRegistration", type="date",
          :placeholder="$t('select_date')",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy",  @change="fieldChanged")
      el-tooltip(placement='right')
        div(slot='content')
          | {{ $t("hint_reg_date")}}
        i.el-icon-question
      el-form-item(:label="$t('grad_date')"
        :prop="fromConsideration ? 'dateOfGraduation' : 'titles.dateOfGraduation'")
        el-date-picker(v-model="title.dateOfGraduation", type="date",
          :placeholder="$t('select_date')",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy",  @change="fieldChanged")
      el-tooltip(placement='right')
        div(slot='content')
          span {{ $t("hint_grad_date") }}
        i.el-icon-question
    div
      el-form-item(:label="$t('duration')"
        :prop="fromConsideration ? 'durationOfStudies' : 'titles.durationOfStudies'")
        el-select(v-model='title.durationOfStudies' , :placeholder="$t('years')",
        @change="fieldChanged")
          el-option(label='1', value='1')
          el-option(label='2', value='2')
          el-option(label='3', value='3')
          el-option(label='4', value='4')
          el-option(label='5', value='5')
          el-option(label='6', value='6')
      el-tooltip(placement='right')
        div(slot='content')
          span {{ $t("hint_duration") }}
        i.el-icon-question
    div
      el-form-item(:label='$t("study_madein")')
        el-switch(v-model="title.studiesInMoreUniversities", :active-text="$t('several_universities')",
          :inactive-text="$t('one_university')" @change='studiesInMoreUniversitiesChanged')
      el-tooltip(placement='right')
        div(slot='content')
          | {{ $t("hint_more_unis") }}
        i.el-icon-question
    div(v-show='title.studiesInMoreUniversities')
      el-form-item(label=' ')
        span {{$t("hint_more_unis2")}}
      div(
        v-for="(additionalUni, index) in additionalUniversities"
        :key="`additional-uni-${index}`"
        class="additional-university-inline-row"
      )
        el-button(
          @click="deleteUniversity(index)"
          size="mini"
          type="danger"
          plain="plain"
          v-show='!applicationFinalSaved'
          class="additional-university-inline-row__delete"
        )
          span {{$t("delete_university")}}
        span(class="additional-university-inline-row__label")
          | {{$t("university")}}
        el-input.additional-university-inline-row__university(
          type="text"
          v-model="additionalUni.university"
          @change="additionalUniversitiesChanged"
          @input="additionalUni.university = additionalUni.university.toUpperCase()"
        )
        span(class="additional-university-inline-row__label")
          | {{$t("credits")}}
        el-input.additional-university-inline-row__credits(
          inputmode="numeric"
          v-model.number="additionalUni.credits"
          @change="additionalUniversitiesChanged"
          @blur="markAdditionalCreditsTouched(index)"
        )
        span(
          v-if="visibleCreditsErrors[index]"
          class="additional-university-inline-row__error"
        )
          | {{ visibleCreditsErrors[index] }}
      el-form-item(label=' ')
        el-button(@click="addUniversity" size="mini" type="primary" plain="plain")
          span {{$t("add_university")}}
    university-request-dialog(
      :visible.sync="universityRequestVisible",
      :countryName="universityCountryName",
      :personalDetails="personalDetails",
      :hasContactDetails="hasContactDetails",
      @edit-contact="personalDataVisible = true",
      @sent="universityRequestSent = true"
    )
    personal-data-dialog(
      :visible.sync="personalDataVisible",
      :countries="countries",
      @data-updated="personalDataUpdated"
    )
</template>

<script>
import axios from 'axios'
import config from '../../config.js'
import sharedMethods from './sharedMethods.js'
import InactiveCountryWarning from './InactiveCountryWarning'
import UniversityRequestDialog from './UniversityRequestDialog'
import PersonalDataDialog from '../PersonalDataDialog.vue'
import { selectableCountries, isInactiveCountryId } from '../../utils/countries'

export default {
  components: {
    InactiveCountryWarning,
    UniversityRequestDialog,
    PersonalDataDialog,
  },
  mixins: [sharedMethods],
  props: [
    'title',
    'countries',
    'applicationFinalSaved',
    'fromConsideration',
    'formValidation',
    'personalDetails',
  ],
  mounted() {
    if (this.title.country.name != null) {
      this.countryChoiceId = this.title.country.id
      this.loadUniversities(this.title.country.id, this.applicationFinalSaved)
    }
    this.emitAdditionalCreditsValidation()
  },
  data() {
    return {
      additionalUniversities: this.title.additionalUniversities,
      gettingUniversities: false,
      countryChoiceId: '',
      disableUniversity: this.title.country.name === null,
      universities: [],
      touchedAdditionalCredits: [],
      universityRequestVisible: false,
      universityRequestSent: false,
      personalDataVisible: false,
    }
  },
  computed: {
    // The university request needs an email and at least one phone (mobile or landline).
    hasContactDetails() {
      const pd = this.personalDetails || {}
      const filled = value => !!value && String(value).trim() !== ''
      return filled(pd.email) && (filled(pd.mobile) || filled(pd.telephone))
    },
    // Country shown in the university request message.
    universityCountryName() {
      return this.title.country.name === 'other'
        ? this.title.country.countryInserted || ''
        : this.title.country.name || ''
    },
    countryOptions() {
      return selectableCountries(this.countries, this.applicationFinalSaved)
    },
    // Locked application with an inactive country of study: highlight and warn.
    countryInactive() {
      return (
        this.applicationFinalSaved &&
        isInactiveCountryId(this.countries, this.title.country.id)
      )
    },
    // Returns an array of error messages (or null) for each additional university credits field.
    // A credits value is valid if it is a number between 0 and 1000 (inclusive).
    creditsErrors() {
      if (!this.title.studiesInMoreUniversities) {
        return []
      }
      return this.additionalUniversities.map(additionalUni => {
        const val = additionalUni.credits
        if (val === '' || val === null || val === undefined) {
          return this.$t('ectsInsertMsg')
        }
        const num = Number(val)
        if (isNaN(num) || num < 0 || num > 1000) {
          return this.$t('ectsInsertMsg')
        }
        return null
      })
    },
    visibleCreditsErrors() {
      if (!this.title.studiesInMoreUniversities) {
        return []
      }
      return this.creditsErrors.map((error, index) => {
        if (!error) {
          return null
        }
        return this.formValidation || this.touchedAdditionalCredits[index]
          ? error
          : null
      })
    },
    // True if any additional university has an invalid credits value.
    hasInvalidCredits() {
      return this.creditsErrors.some(err => err !== null)
    },
    // Returns the recognition_status of the currently selected university, if any.
    selectedUniversityRecognitionStatus() {
      if (!this.title.university.id) {
        return null
      }
      const selected = this.universities.find(
        university => university.id === this.title.university.id
      )
      return selected && selected.recognition_status
        ? selected.recognition_status.split(' ').join('-')
        : null
    },
    // Returns a CSS class matching the selected university's recognition status,
    // applied to the select display text and the full-name div.
    selectedUniversityColorClass() {
      if (!this.selectedUniversityRecognitionStatus) {
        return ''
      }
      return `university-selected--${this.selectedUniversityRecognitionStatus}`
    },
    // Show legend in all cases except when the application is locked (final-saved)
    // and the selected university is a legacy one (no recognition status).
    showUniversityLegend() {
      if (this.applicationFinalSaved && !this.selectedUniversityRecognitionStatus) {
        return false
      }
      return true
    },
  },
  methods: {
    // Load universities for a given country, filtering to new institutes only (is_new_institute === 1).
    // If the currently selected university is not in the filtered list, clear it.
    loadUniversities(countryId, loadAll) {
      this.gettingUniversities = true
      axios
        .get(`${config.BASE_URL}/countries/${countryId}/universities`)
        .then(response => {
          // Ignore a late response for a country that is no longer selected
          // (e.g. cleared because it became inactive).
          if (countryId !== this.title.country.id) {
            this.gettingUniversities = false
            return
          }
          const allUniversities = response.data.data

          if (loadAll) {
            // Locked application: show all universities
            this.universities = allUniversities
          } else {
            // Editable application: show only new institutes
            const newUniversities = allUniversities.filter(
              university => university.is_new_institute === 1
            )
            this.universities = newUniversities

            // If a university is already selected, check if it's old institute
            if (
              this.title.university &&
              this.title.university.id !== null &&
              this.title.university.isNewInstitute != null &&
              this.title.university.isNewInstitute !== 1
            ) {
              // Clear the university selection if it's old institute
              this.title.university = {
                id: null,
                name: null,
                universityInserted: '',
              }
            }
          }

          this.disableUniversity = false
          this.gettingUniversities = false
        })
        .catch(err => {
          this.backendErrorNotify(err)
          this.disableUniversity = false
          this.gettingUniversities = false
          this.universities = []
          this.$notify.warning({
            title: this.$t('warning'),
            message: this.$t('no_unis_found'),
            offset: 100,
          })
        })
    },
    // Returns a CSS class for the university option based on recognition status.
    universityOptionClass(university) {
      if (!university.recognition_status) {
        return ''
      }
      return `university-option--${university.recognition_status.split(' ').join('-')}`
    },
    markAdditionalCreditsTouched(index) {
      this.$set(this.touchedAdditionalCredits, index, true)
    },
    universityInsertedChanged() {
      this.initializeColFacDep()
      this.colleges = []
      this.faculties = []
      this.departments = []
      this.collegeFaculties = []
      this.colFacDepartments = []
      this.$emit('titleDetailsChanged', this.title)
    },
    countryInsertedChanged() {
      this.$emit('titleDetailsChanged', this.title)
    },
    emitAdditionalCreditsValidation() {
      this.$emit('additionalCreditsValid', !this.hasInvalidCredits)
    },
    additionalUniversitiesChanged() {
      this.title.additionalUniversities = this.additionalUniversities
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    addUniversity() {
      this.additionalUniversities.push({
        university: '',
        credits: '',
      })
      this.touchedAdditionalCredits.push(false)
      this.title.additionalUniversities = this.additionalUniversities
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    deleteUniversity(index) {
      this.additionalUniversities.splice(index, 1)
      this.touchedAdditionalCredits.splice(index, 1)
      if (this.additionalUniversities.length === 0) {
        this.title.studiesInMoreUniversities = false
      }
      this.title.additionalUniversities = this.additionalUniversities
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    initializeColFacDep() {
      // this.title.faculty = {id: null, name: 'other', facultyInserted: 'ΔΕΝ ΕΧΕΙ ΟΡΙΣΘΕΙ'}
      // this.title.department = {id: null, name: 'other', departmentInserted: 'ΔΕΝ ΕΧΕΙ ΟΡΙΣΘΕΙ'}
      // this.title.college = {id: null, name: 'other', collegeInserted: 'ΔΕΝ ΕΧΕΙ ΟΡΙΣΘΕΙ'}
      this.$emit('titleDetailsChanged', this.title)
    },
    studiesInMoreUniversitiesChanged() {
      this.additionalUniversities = [{ university: null, credits: null }]
      this.title.additionalUniversities = [{ university: null, credits: null }]
      this.touchedAdditionalCredits = [false]
      this.emitAdditionalCreditsValidation()
      this.$emit('titleDetailsChanged', this.title)
    },
    // Refresh the contact details after they are saved from the PersonalDataDialog,
    // which also updates them in the sessionStorage working application.
    personalDataUpdated() {
      if (!this.personalDetails) {
        return
      }
      try {
        const application = JSON.parse(
          sessionStorage.getItem('workingApplication')
        )
        if (application && application.personalDetails) {
          const pd = application.personalDetails
          this.personalDetails.telephone = pd.telephone
          this.personalDetails.mobile = pd.mobile
          this.personalDetails.email = pd.email
        }
      } catch (error) {
        console.error('Error parsing workingApplication:', error)
      }
    },
    countrySelected(country) {
      // A new country may need a request for a different university
      this.universityRequestSent = false
      this.title.university = { id: null, name: null, universityInserted: '' }
      this.initializeColFacDep()
      if (country !== 'other') {
        this.title.country.countryInserted = ''
        this.title.country.name = this.countries.find(
          countr => countr.id === country
        ).name
        this.title.country.id = country
        this.countryChoiceId = country
        this.$emit('titleDetailsChanged', this.title)
        // Todo: /universities are called twice in 3 places???
        this.loadUniversities(country, this.applicationFinalSaved)
      } else {
        this.disableUniversity = false
        this.gettingUniversities = false
        this.universities = []
        this.title.country.id = null
      }
    },
    universitySelected(university) {
      this.initializeColFacDep()
      this.title.university.universityInserted = ''
      if (university !== 'other') {
        this.title.university.name = this.universities.find(
          uni => uni.id === university
        ).name
        this.title.university.id = university
        this.$emit('titleDetailsChanged', this.title)
      } else {
        this.title.university.id = null
        // The university name is no longer typed in: it is sent with the university request
        this.title.university.universityInserted = null
        this.$emit('titleDetailsChanged', this.title)
      }
    },
    fieldChanged(el) {
      this.$emit('titleDetailsChanged', this.title)
    },
    // Editable application: clear an inactive country of study, together with
    // the university that belongs to it, so the user has to select again.
    clearInactiveCountry() {
      if (
        this.applicationFinalSaved ||
        !this.title ||
        !this.title.country ||
        !isInactiveCountryId(this.countries, this.title.country.id)
      ) {
        return
      }
      this.title.country.id = null
      this.title.country.name = null
      this.title.country.countryInserted = ''
      this.title.university = { id: null, name: null, universityInserted: '' }
      this.countryChoiceId = ''
      this.universities = []
      this.disableUniversity = true
      this.$emit('titleDetailsChanged', this.title)
    },
  },
  watch: {
    title: {
      handler: function(newVal, oldVal) {
        this.clearInactiveCountry()
        // Check if selected university is legacy when loading editable application
        if (
          !this.applicationFinalSaved &&
          this.title.university &&
          this.title.university.id !== null &&
          this.title.university.isNewInstitute != null &&
          this.title.university.isNewInstitute !== 1
        ) {
          this.title.university = {
            id: null,
            name: null,
            universityInserted: '',
          }
        }
        // Editable application with "Other" university (e.g. returned to the user):
        // clear the previously inserted name, the user sends a university request instead.
        if (
          !this.applicationFinalSaved &&
          this.title.university &&
          this.title.university.name === 'other' &&
          this.title.university.universityInserted
        ) {
          this.title.university.universityInserted = null
        }

        if (
          oldVal &&
          oldVal.country &&
          newVal.country &&
          newVal.country.name !== oldVal.country.name &&
          newVal.country.name != null
        ) {
          this.countryChoiceId = newVal.country.id
          this.loadUniversities(newVal.country.id, this.applicationFinalSaved)
        }
        this.additionalUniversities = newVal.additionalUniversities
        this.touchedAdditionalCredits = this.additionalUniversities.map(
          (item, index) => this.touchedAdditionalCredits[index] || false
        )
        this.emitAdditionalCreditsValidation()
        // this.collegeOrFaculty = this.title.collegeOrFaculty === null ||
        // this.title.collegeOrFaculty === undefined
        //   ? null
        //   : (this.title.collegeOrFaculty ? 'college' : 'faculty')
      },
      deep: true,
      immediate: true,
    },
    applicationFinalSaved: {
      handler: function(newVal) {
        this.clearInactiveCountry()
        // Re-load universities when the application switches between locked/unlocked
        if (this.title.country.name != null) {
          this.loadUniversities(this.title.country.id, newVal)
        }
      },
    },
    countries: 'clearInactiveCountry',
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.info-header {
  border-radius: 5px 20px;
  border: 2px solid #7fa3bb;
  padding: 5px;
  margin: 5px;
  width: 380px;
}

.el-input {
  width: 240px;
}
.el-autocomplete {
  width: 440px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 9px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
// @media only screen and (min-width: $screen-sm-min) {
//   .maxSteps {
//     display: none;
//   }
// }
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
.el-input {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 540px;
  }
}
.el-textarea {
  &.biggest {
    width: 540px;
  }
}
.el-select {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 1100px;
  }
  &.countries {
    width: 440px;
  }
}
.hideSMup {
  display: none;
}
.hideSMdown {
  display: block;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1b91de;
}

.additional-university-inline-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.additional-university-inline-row__delete {
  flex: 0 0 auto;
}

.additional-university-inline-row__label {
  flex: 0 0 auto;
}

.additional-university-inline-row__university {
  width: 240px;
}

.additional-university-inline-row__credits {
  width: 120px;
}

.additional-university-inline-row__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

.contact-details-link {
  margin-left: 10px;
}

@media only screen and (max-width: $screen-sm-min) {
  .hideSMup {
    display: block;
  }
  .hideSMdown {
    display: none;
  }
  .el-autocomplete {
    width: 240px;
  }
  .el-input {
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 240px;
    }
  }
  .el-select {
    &.countries {
      width: 240px;
    }
    &.big {
      width: 240px;
    }
    &.biggest {
      width: 240px;
    }
  }
  .additional-university-inline-row {
    align-items: flex-start;
  }
  .additional-university-inline-row__university {
    width: 240px;
  }
  .additional-university-inline-row__credits {
    width: 120px;
  }
  .additional-university-inline-row__error {
    white-space: normal;
  }
}

// University option colors based on recognition status
// These styles target the dropdown options rendered by Element UI
.university-option--recognized {
  color: #67c23a; // Element UI success green
}

.university-option--unrecognized {
  color: #f56c6c; // Element UI danger red
}

.university-option--under-review {
  color: #0000ff; // Element UI warning amber/orange
}

// Colors the selected university text inside the select input and the
// full-name display div, matching the recognition status color.
.university-selected--recognized {
  ::v-deep .el-input__inner {
    color: #67c23a !important;
  }
  color: #67c23a;
}

.university-selected--unrecognized {
  ::v-deep .el-input__inner {
    color: #f56c6c !important;
  }
  color: #f56c6c;
}

.university-selected--under-review {
  ::v-deep .el-input__inner {
    color: #0000ff !important;
  }
  color: #0000ff;
}
</style>
